import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PrintSize, DeliveryOption } from '../../prop-types';
import BulkQuantityChangeSize from './size';
import photoRootIds from '../photo-root-ids';
import screenAndStyle from '../../../_utils/screen-and-style';

export default function BulkQuantityChange({
  availableSizes,
  photos,
  disabled,
}) {
  const [showAllSizes, setShowAllSizes] = useState(false);
  const isMobile = screenAndStyle.assumePhoneOrSmallScreen();

  function numberOfSizesToShow() {
    if (isMobile) {
      return 4;
    }
    if (screenAndStyle.isBootstrapLG()) {
      return 5;
    }

    return 8;
  }

  function handleShowMoreSizesClick() {
    setShowAllSizes(!showAllSizes);
  }

  const moreFewerButtonToggleLabel = `${showAllSizes ? 'Fewer' : 'More'} sizes`;
  const sizes = showAllSizes
    ? availableSizes
    : availableSizes.slice(0, numberOfSizesToShow());
  const rootIds = photoRootIds(photos, true);
  const moreButton = (availableSizes.length > sizes.length || showAllSizes) && (
    <div className="bulk-quantity-change__sizes-toggle d-flex">
      <button
        type="button"
        className="btn btn-link btn-underline px-0 py-1"
        aria-label={`View ${moreFewerButtonToggleLabel}`}
        onClick={handleShowMoreSizesClick}>
        {moreFewerButtonToggleLabel}
      </button>
    </div>
  );

  if (disabled && isMobile) {
    return <div className="bulk-quantity-change"></div>;
  }
  return (
    <div className="bulk-quantity-change">
      <h6>Quick Order:</h6>
      <p>Select and apply options to all photos</p>
      <div className="w-100 d-flex">
        <div className="bulk-quantity-change__sizes">
          {sizes.map((size) => (
            <BulkQuantityChangeSize
              {...size}
              title={
                size.title + (size.options?.border === true ? ' Border' : '')
              }
              key={size.key}
              sizeKey={size.key}
              rootIds={rootIds}
              disabled={disabled}
            />
          ))}
        </div>
        {!isMobile && moreButton}
      </div>
      {isMobile && moreButton}
    </div>
  );
}

BulkQuantityChange.propTypes = {
  availableSizes: PropTypes.arrayOf(PrintSize).isRequired,
  photos: PropTypes.arrayOf(PrintSize),
  disabled: PropTypes.bool.isRequired,
  deliveryOption: DeliveryOption.isRequired,
};

BulkQuantityChange.defaultProps = {
  photos: [],
};
